import React, { useContext, useState } from 'react';
import {useLocation} from 'react-router-dom';
import {isSongbook} from '../../dashboard/component/dashboardData';
import {songPathFromUrl} from '../../../shared/services/songPathUtils';
import { AppCtx } from '../../../AppCtx';
import "./ContentViewComponent.css";

const ContentViewComponent = ({ children, shrinkWithFileBrowser = true }) => {
  const {pathname} = useLocation();
  const [showShortcuts, setShowShortcuts] = useState(false);
  const { zooms, isPresentationMode, isBlankScreen, setIsBlankScreen, isTopMenuVisible,
    isFileBrowserVisible, isPresentationControlPanelVisible } = useContext(AppCtx);
  const isFramedSongView = isFileBrowserVisible && !isPresentationMode && !shrinkWithFileBrowser;

  const songScreen = pathname.startsWith('/songs/') && isSongbook(songPathFromUrl(pathname));
  const appScale = !songScreen ? (zooms?.app || 1) : 1;

  const besideSidebar = isFileBrowserVisible && !isPresentationMode;
  const shrinksBesideSidebar = !isFramedSongView && besideSidebar && shrinkWithFileBrowser;
  const viewStyle = {
    marginTop: isTopMenuVisible && !isPresentationMode ? '38px' : '0',
    position: 'fixed',
    zIndex: 0,
    top: 0,
    left: 0,
    overflow: isPresentationMode ? 'hidden' : 'auto',
    // An inline width would beat the sidebar rule and push the page under the right edge.
    width: shrinksBesideSidebar ? undefined : '100vw',
    height: isPresentationControlPanelVisible && !isPresentationMode
      ? (isTopMenuVisible ? 'calc(var(--app-viewport-height) - 38px - 62px)' : 'calc(var(--app-viewport-height) - 62px)')
      : (isTopMenuVisible && !isPresentationMode ? 'calc(var(--app-viewport-height) - 38px)' : 'var(--app-viewport-height)')
  };
  const viewClassName = [
    'song-view',
    isFramedSongView ? 'song-view-framed' : '',
    shrinksBesideSidebar ? 'song-view--beside-sidebar' : ''
  ].filter(Boolean).join(' ');

  const shortcutsStyle = {
    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    backgroundColor: 'var(--background-color)', color: 'var(--text-color)', padding: '20px',
    borderRadius: '8px', border: '1px solid var(--border-color-verse)',
    boxShadow: '0 0 10px var(--shortcuts-shadow)', zIndex: 10000
  };

  return (<>
    <div className={`song-view-frame${isFramedSongView ? '' : ' song-view-frame-plain'}`} style={isFramedSongView ? {
        top: isTopMenuVisible ? '38px' : '0',
        height: `calc(var(--app-viewport-height) - ${isTopMenuVisible ? 38 : 0}px - ${isPresentationControlPanelVisible ? 62 : 0}px)`
      } : undefined}>
      <div className={`song-view-surface${isFramedSongView ? '' : ' song-view-surface-plain'}`}>
        <div className={viewClassName} style={isFramedSongView ? undefined : viewStyle}>
          <div className="screen-zoom-content" data-zoom-scope={appScale !== 1 || !songScreen ? "app" : undefined} style={{zoom: appScale, height: '100%'}}>{children}</div>
        </div>
      </div>
    </div>
    {showShortcuts && <div style={shortcutsStyle} onClick={() => setShowShortcuts(false)}>
      <h3 style={{ marginTop: 0 }}>Skróty klawiszowe</h3>
      <table><tbody style={{ color: 'var(--text-color)' }}>
        <tr><td><kbd>F5</kbd> lub <kbd>F11</kbd> lub <kbd>F</kbd></td><td>Tryb prezentacji</td></tr>
        <tr><td><kbd>C</kbd></td><td>Pokazuj/ukryj akordy</td></tr>
        <tr><td><kbd>M</kbd></td><td>Pokazuj/ukryj menu</td></tr>
        <tr><td><kbd>L</kbd></td><td>Zwiń/rozwiń wszystkie pieśni</td></tr>
        <tr><td><kbd>B</kbd> lub <kbd>.</kbd></td><td>Czarny ekran</td></tr>
        <tr><td><kbd>H</kbd> lub <kbd>F1</kbd></td><td>Pokaż/ukryj pomoc</td></tr>
        <tr><td><kbd>Esc</kbd></td><td>Wyjście z trybu prezentacji</td></tr>
      </tbody></table>
      <div style={{ textAlign: 'center', marginTop: '10px', color: 'var(--meta-background-color-alt)' }}>
        Kliknij gdziekolwiek aby zamknąć
      </div>
    </div>}
    {isBlankScreen && <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'black',
      zIndex: 9999, cursor: 'none'
    }} onClick={() => setIsBlankScreen(false)} />}
  </>);
};
export default ContentViewComponent;
